export default "__VITE_ASSET__Ci_m3WVg__"